export default __webpack_public_path__ + "static/media/home-promo-image.ce3701cf.png";